<template>
  <common-dialog ref="dialog" width="600px" form-label-width="100px" show-save-button title="添加地址标记" id-key="id"
    :data="data" :form-rules="rules" :save-func="saveDataFunc" @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-form-item label="快递公司">
        <el-input v-model="data.快递" disabled></el-input>
      </el-form-item>
      <el-form-item label="网点发货地址">
        <el-radio-group v-model="data.网点发货地址">
          <div v-for="(i,k) in 发货地址列表" :key="k" style="line-height: 30px;">
            <el-radio :label="i.id">{{ i.name }} 剩 {{ i.number }} 单</el-radio>
          </div>
        </el-radio-group>
      </el-form-item>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        id: 0,
        快递LOGO: "",
        快递: "",
        所属店铺: "",
        网点发货地址: 1,
        网点发货地址文本: "",
        余额: null,
        已用: null,
        取消: null,
        是否启用: false,
        模板名称: "",
        模板样式: "",
        默认发货地址: "",
        isChange: false,
      },
      发货地址列表: [{
        id: 1,
        name: "浙江省金华市义乌市樊村46号楼5单元1楼",
        number: 9
      }, {
        id: 2,
        name: "上海市上海市闽行区七宝镇中春路7335号",
        number: 300
      }],
      // api: require('@/api/ent/dp').default,
      rules: {
        address: [{ required: true, message: '地址关键字不能为空' }],
      },
    };
  },
  methods: {
    saveDataFunc() {
      return new Promise((resolve, reject) => {
        resolve({ Code: 0, Msg: null })
      })
    },
  },
};
</script>
